import React from 'react';

const Logo = ({ className = "w-10 h-10", textClassName = "text-xl", showText = true }) => {
    return (
        <div className="flex items-center gap-3 group transition-all duration-300">
            <div className={`relative flex items-center justify-center shrink-0 ${className}`}>
                {/* Modern Minimalist Logo Design */}
                <svg
                    viewBox="0 0 100 100"
                    className="w-full h-full drop-shadow-sm group-hover:drop-shadow-md transition-all duration-300"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    {/* Main Architectural Frame */}
                    <path
                        d="M20 80V30L50 15L80 30V80"
                        stroke="currentColor"
                        strokeWidth="8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="text-sky-500"
                    />
                    {/* Internal Cloud/Skyline line */}
                    <path
                        d="M35 55C35 45 45 40 50 40C55 40 65 45 65 55"
                        stroke="currentColor"
                        strokeWidth="6"
                        strokeLinecap="round"
                        className="text-navy-900 group-hover:text-sky-600 transition-colors duration-300"
                    />
                    {/* Foundation Line */}
                    <path
                        d="M15 80H85"
                        stroke="currentColor"
                        strokeWidth="4"
                        strokeLinecap="round"
                        className="text-navy-400"
                    />
                </svg>
            </div>

            {showText && (
                <div className="flex flex-col -space-y-1">
                    <span className={`font-heading font-bold text-navy-900 ${textClassName} tracking-tight`}>
                        Estate<span className="text-sky-500">Cloud</span>
                    </span>
                    <span className="text-[10px] uppercase tracking-[0.2em] text-navy-400 font-medium">
                        Premium Real Estate
                    </span>
                </div>
            )}
        </div>
    );
};

export default Logo;
